import { z } from "zod";

export const CreateImageUploadRequestSchema = z.object({
  uuid: z.uuid(),
  fileName: z.string(),
  mimeType: z.enum(["image/png", "image/jpeg", "image/heic"]),
  fileSizeBytes: z.number(),
});

export type CreateImageUploadRequest = z.infer<typeof CreateImageUploadRequestSchema>;

export const ImageUploadResponseSchema = z.object({
  uuid: z.uuid(),
  uploadUrl: z.string(),
  fileName: z.string(),
  mimeType: z.string(),
  fileSizeBytes: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type ImageUploadResponse = z.infer<typeof ImageUploadResponseSchema>;

export const ImageUploadDetailSchema = z.object({
  uuid: z.uuid(),
  downloadUrl: z.string(),
  fileName: z.string(),
  mimeType: z.string(),
  fileSizeBytes: z.number(),
  companyUuid: z.string(),
  ticketUuid: z.uuid().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type ImageUploadDetail = z.infer<typeof ImageUploadDetailSchema>;

export const IMAGE_UPLOAD_CONSTRAINTS = {
  maxFileSizeMB: 10,
  maxFileSizeBytes: 10 * 1024 * 1024,
  maxFiles: 5,
  acceptedMimeTypes: ["image/png", "image/jpeg", "image/heic"] as const,
  acceptedFormats: ["PNG", "JPG", "JPEG", "HEIC"] as const,
} as const;

export type ImageUploadMimeType = (typeof IMAGE_UPLOAD_CONSTRAINTS.acceptedMimeTypes)[number];

export enum ImageUploadStatus {
  Pending = "pending",
  Uploading = "uploading",
  Success = "success",
  Error = "error",
}

export type ImageUploadInfo = {
  uuid: string;
  file: File;
  previewUrl: string;
  status: ImageUploadStatus;
  errorMessage?: string;
};
